export const SIDE_PANEL_CONTENT = {
  NONE: 'NONE',
  ORDER_SUMMARY: 'ORDER_SUMMARY',
  SHIPMENTS: 'SHIPMENTS',
  RETURNS: 'RETURNS',
};
